import { FormattedMessage } from 'react-intl'
import { Link as RouterLink } from '@tanstack/react-router'

import { Link } from '@gto/ui/link'

const TermsLink = ({ children }: { children: React.ReactNode }) => {
  return (
    <Link
      viewTransition
      as={RouterLink}
      target="_blank"
      to="/terms-of-service"
    >
      {children}
    </Link>
  )
}

const PrivacyLink = ({ children }: { children: React.ReactNode }) => {
  return (
    <Link
      viewTransition
      as={RouterLink}
      target="_blank"
      to="/privacy-policy"
    >
      {children}
    </Link>
  )
}

export const PrivacyAgreementLabel = () => {
  return (
    <FormattedMessage
      id="auth.signup.privacyAgreement"
      values={{
        terms: (chunks: React.ReactNode) => <TermsLink>{chunks}</TermsLink>,
        privacy: (chunks: React.ReactNode) => <PrivacyLink>{chunks}</PrivacyLink>,
      }}
    />
  )
}
